import React, { useEffect, useState } from "react";
import { Catalog, Gauge, ReviewedBar, StudyInfo } from "../components";
import { Barometer } from "../../types";
import { evidenceText } from "../../formatters";
import { useResizeDetector } from "react-resize-detector";
interface Props {
  onClose: () => void;
  barometer: Barometer;
}

export default function Block({ onClose, barometer }: Props) {
  const { width, height: _, ref } = useResizeDetector();
  const [showMobile, setShowMobile] = useState(false);
  
  useEffect(() => {
    // Introduced as the we cant make the window size will decide div size.
    // Thus we cant trust media queries, and instead we should listen on div resize.
    setShowMobile(width ? width < 640 : true);
  }, [width]);

  return (
    // @ts-ignore ref creates type errors.
    <div ref={ref} className="border relative">
      <button className="absolute right-3 top-3" onClick={onClose}>
        <img
          src={require("../../assets/icons/close.png")}
          className="w-4 h-4"
          alt="luk"
        />
      </button>
      <div className="p-12 text-center">
        <h2 className="text-3xl mb-1.5">Evidensbarometer</h2>
        <p className="text-lg mb-4">
          Hvor stærk evidens giver studiet omtalt i denne artikel?
        </p>
        <Gauge evidence={barometer.evidence_level} />
        <StudyInfo barometer={barometer} className="mt-4" />
        <ReviewedBar reviewed={barometer.peer_reviewed ?? false} />
        <p className="text-sm sm:text-lg mb-6">
          (Peer review betyder, at andre forskere har kvalitetssikret den
          videnskabelige artikel før udgivelse.{" "}
          <a
            href="https://videnskab.dk/kultur-samfund/hvad-er-peer-review/"
            target="_blank"
            rel="noreferrer"
            className="link"
          >
            Læs mere
          </a>
          )
          <br />
          <br />
          Videnskab.dk's Evidensbarometer rangerer sundhedsforskning ud fra 4
          kriterier:
        </p>
        <Catalog barometer={barometer} showMobile={showMobile} />
        <p className="p-4 border-2 border-blue-300 text-lg rounded-lg">
          {evidenceText(barometer.evidence_level)}
        </p>
      </div>
      <a
        href="https://videnskab.dk/evidensbarometer/"
        target="_blank"
        rel="noreferrer"
        className="hover:underline text-2xl flex justify-center items-center p-6 border-t border-black text-black"
      >
        Læs mere om Evidensbarometeret{" "}
        <img
          className="h-5 ml-1"
          src={require("../../assets/icons/arrow.png")}
          alt="pil"
        />
      </a>
    </div>
  );
}
